<template>
  <div class="input-select relative">
    <SelectRoot
      v-model="modelValue"
      v-model:open="selectOpen"
      :by="itemsKeyName"
      @update:model-value="onUpdateModelValue"
    >
      <SelectTrigger
        v-bind="$attrs"
        :class="selectOpen ? 'outline-secondary outline' : ''"
        class="surface focus:outline-secondary flex w-full items-center justify-between space-x-2 rounded-md border-none px-2 py-1 leading-none select-none sm:text-sm placeholder:sm:text-sm"
      >
        <SelectValue :placeholder="($attrs.placeholder as string) ?? ''">
          <template #default>
            {{ modelValue ? getItemValue(modelValue) : $attrs.placeholder }}
          </template>
        </SelectValue>
        <FontAwesomeIcon :icon="['fas', selectOpen ? 'chevron-up' : 'chevron-down']" size="sm" />
      </SelectTrigger>

      <SelectPortal>
        <SelectContent
          class="surface z-40 min-w-(--reka-select-trigger-width) rounded-md border-none text-sm shadow-lg focus:outline-hidden"
          position="popper"
          :side-offset="5"
        >
          <SelectViewport class="p-1 select-none">
            <SelectItem
              v-for="item in items"
              :key="getItemKey(item)"
              :value="item"
              class="data-highlighted:primary data-[state=checked]:primary relative flex cursor-pointer items-center rounded-sm p-2 pl-8 outline-none data-highlighted:cursor-pointer data-[state=checked]:cursor-pointer"
            >
              <SelectItemIndicator class="absolute left-2 flex items-center justify-center">
                <FontAwesomeIcon :icon="['fas', 'check']" size="xs" />
              </SelectItemIndicator>
              <SelectItemText>
                {{ getItemValue(item) }}
              </SelectItemText>
            </SelectItem>
          </SelectViewport>
        </SelectContent>
      </SelectPortal>
    </SelectRoot>
  </div>
</template>

<script setup lang="ts">
import {
  SelectContent,
  SelectItem,
  SelectItemIndicator,
  SelectItemText,
  SelectPortal,
  SelectRoot,
  SelectTrigger,
  SelectValue,
  SelectViewport
} from "reka-ui"
import { nextTick, ref } from "vue"

const modelValue = defineModel<any | null>({ required: true })
const selectOpen = ref(false)

const emit = defineEmits(["update:modelValue", "select"])

const props = withDefaults(
  defineProps<{
    items: any[]
    itemsKeyName?: string
    itemsValueName?: string
  }>(),
  {
    itemsKeyName: "key",
    itemsValueName: "value"
  }
)

function getItemKey(item: any) {
  return item[props.itemsKeyName]
}

function getItemValue(item: any) {
  return item[props.itemsValueName]
}

async function onUpdateModelValue() {
  await nextTick() // Wait for the model to be updated
  emit("select", modelValue.value)
}

function open() {
  selectOpen.value = true
}

defineExpose({ open })

defineOptions({
  inheritAttrs: false
})
</script>

<style scoped></style>
